export default __webpack_public_path__ + "static/media/tarima8.a8a21a3e.png";